import { Row, Col, Card, Table, Typography, Tabs, Select, Tooltip, Button, Image } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import { AppStateContext } from "../../context/AppContext";
import ShowVideoModal from "../../modals/ShowVideoModal";
import notfound from "../../assets/images/not_found.png";
import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";
import DeleteModal from "../../components/DeleteModal";

const { TabPane } = Tabs;
const { Title } = Typography
function ViewPredefined() {
  const heading = "Challenges";
  const { setPageHeading } = useContext(AppStateContext);
  const params = useParams();
  const { request } = useRequest();
  const location = useLocation();
  const [refresh, setRefresh] = useState(false);
  const [mediaPagination, setMediaPagination] = useState({ current: 1, pageSize: 10 });
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [showVideo, setShowVideo] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [selected, setSelected] = useState();
  const [mediaLoading, setMediaLoading] = useState(false);
  const [challengeMedia, setChallengeMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [challengeData, setChallengeData] = useState([]);
  const [challengeStats, setChallengeStats] = useState();

  const onDelete = (id) => {
    setMediaLoading(true);
    request({
      url: apiPath.getChallenges + "/media-content/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setMediaLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        setMediaLoading(false);
        ShowToast(error, Severty.ERROR);

      },
    });
  };





  const mediaColumns = [
    {
      title: "src",
      dataIndex: "url",
      key: "url",
      render: (_, { url, type }) =>
        type === "Video" ? (
          <video
            className="table-img"
            width={50}
            src={url}
            onClick={() => {
              setSelected(url);
              setShowVideo(true);
            }}
          />
        ) : (
          <Image width={50} src={url ? url : notfound} className="table-img" />
        ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => {
        return title ? <span className="cap">{title}</span> : "-";
      },
    },
    {
      title: "Day Number (Day's)",
      key: "day_number",
      dataIndex: "day_number",
      sorter: (a, b) => (a?.day_number || 0) - (b?.day_number || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { day_number }) => {
        return day_number ? day_number : "-";
      },
    },
     {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => a?.description?.localeCompare(b?.description),
    sortDirections: ["ascend", "descend"],
    render: (_, { description }) => {
      return description ? description : "-";
    },
  },
    {
      title: "total liked count",
      key: "liked_by",
      dataIndex: "liked_by",
      sorter: (a, b) => (a?.like_count || 0) - (b?.like_count || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { like_count }) => {
        return like_count ? like_count : "0";
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",

      render: (_, { created_at }) => {
        return moment(created_at).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                title={"Delete"}
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  showDeleteModal(true);
                }}
              >
                <img src={deleteWhiteIcon} />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];



  const columns = [
    {
      title: "Challenge",
      dataIndex: "challenge",
      key: "challenge",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenger_challenge }) => {
        return challenger_challenge
          ? challenger_challenge?.challenge_id?.title
          : "-";
      },
    },
    {
      title: "Challenger",
      dataIndex: "challenger",
      key: "challenger",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenger }) => {
        return challenger ? challenger?.name : "-";
      },
    },
    {
      title: "Invitee",
      dataIndex: "invitee",
      key: "invitee",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { receiver }) => {
        return receiver ? receiver?.name : "-";
      },
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: 200,
      render: (_, { duration }) => {
        return duration ? duration : "-";
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },

  ];

  const count = [
    {
      today: "Number of Total Used",
      title: `${challengeStats?.total_used || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "1",
    },
    {
      today: "Number of Total Media",
      title: `${challengeStats?.total_media || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "2",
    },
    {
      today: "Number of Total Skipped",
      title: `${challengeStats?.challenges || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "3",
    },
    {
      today: "Number of Total Check-In",
      title: `${challengeStats?.challenges || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "4",
    },
    {
      today: "Number of Total Completed",
      title: `${challengeStats?.challenges || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "5",
    },
    {
      today: "Number of Total Progress",
      title: `${challengeStats?.challenges || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "6",
    },


  ];


  const fetchMediaData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    setMediaLoading(true)
    request({
      url:
        apiPath.getAllChallenges +
        `/media-contentt/${params.id}?status=${filterActive ? filterActive.join(",") : ""}&current=${pagination ? pagination.current : 1
        }&pageSize=${pagination ? pagination.pageSize : 10}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setMediaLoading(false)
        setChallengeMedia(data?.data ?? []);
        setMediaPagination(() => ({
          current: data?.data?.page,
          pageSize: data?.data?.pageSize,
          total: data?.total,
        }));
      },
      onError: (error) => {
        console.log(error);
        setMediaLoading(false)


        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchChallengeData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    setLoading(true)
    request({
      url:
        apiPath.getChallenges +
        `/view-challenge/${params.id}?status=${filterActive ? filterActive.join(",") : ""}&current=${pagination ? pagination.current : 1
        }&pageSize=${pagination ? pagination.pageSize : 10}`,
      method: "GET",
      onSuccess: ({ data }) => {
        console.log(data,"asjmdadjdajk")
        setLoading(false);
        setChallengeData(data?.data ?? []);
        setChallengeStats(data?.challengeStats ?? {})
        setPagination(() => ({
          current: data?.data?.page,
          pageSize: data?.data?.pageSize,
          total: data?.total,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    if (!params.id) return;
    fetchMediaData(mediaPagination, null, null);
    fetchChallengeData(pagination, null, null);
  }, [params.id, refresh]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);



  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={24}>
          <Row className="rowgap-vbox" gutter={[24, 16]}>
            {count.map((c, index) => {
              return (
                <Col
                  key={index}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={8}
                  xxl={6}
                  className="mb24"
                  style={{ paddingRight: "0px" }}
                >
                  <Card
                    bordered={false}
                    className="criclebox"
                    style={{ height: "100%" }}
                  >
                    <div className="number">
                      <Row align="middle" gutter={[24, 0]}>
                        <Col xs={18}>
                          <span>{c.today}</span>
                          <Title level={3}>{c.title}</Title>
                        </Col>
                        <Col xs={6}>
                          {" "}
                          <div className="icon-box">{c.icon}</div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Card
        className="criclebox tablespace mb-24 mt-3"
        title={"Used Challenge"}
      >
        <div className="table-responsive customPagination">
          <Table
            className="ant-border-space main-table"
            loading={loading}
            columns={columns}
            dataSource={challengeData}
            onChange={(pag, filters, sorter) => {
              setPagination(pag);
              fetchChallengeData(pag, filters, sorter);
            }}
            pagination={{
              current: pagination?.current,
              defaultPageSize: 10,
              responsive: true,
              total: pagination?.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
          />
        </div>
      </Card>
      <Card
        className="criclebox tablespace mb-24 mt-3"
        title={"Challenge Media"}
      >
        <div className="table-responsive customPagination">
          <Table
            className="ant-border-space main-table"
            loading={mediaLoading}
            columns={mediaColumns}
            dataSource={challengeMedia}
            onChange={(pag, filters, sorter) => {
              setMediaPagination(pag);
              fetchMediaData(pag, filters, sorter);
            }}
            pagination={{
              current: mediaPagination?.current,
              defaultPageSize: 10,
              responsive: true,
              total: mediaPagination?.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
          />
        </div>
      </Card>

      {showVideo && (
        <ShowVideoModal
          show={showVideo}
          hide={() => {
            setShowVideo(false);
            setSelected();
          }}
          data={selected}
          onOk={() => {
            setShowVideo(false);
            setSelected();
          }}
        />
      )}
      {deleteModal && (
        <DeleteModal
          reasons={[]}
          title={"Delete Content"}
          subtitle={`Are you sure you want to Delete this Content?`}
          show={deleteModal}
          hide={() => {
            showDeleteModal(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
}

export default ViewPredefined;
